export default __webpack_public_path__ + "static/media/Spenden.b96653f7.png";